import Filters from './filters'
import List from './list'
import Stats from './stats'

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    Filters.state,
    List.state,
    Stats.state
  ),
  mutations: Object.assign(
    Filters.mutations,
    List.mutations,
    Stats.mutations
  )
}



// WEBPACK FOOTER //
// ./src/store/transactions/index.js